import axios from "axios";

import { IAdBanner } from "../types/ads";

export const getBanners = () => axios.get<IAdBanner[]>("a_d-banners");
